// extracted by mini-css-extract-plugin
module.exports = {"root":"AccordionItemBlok_root__1zBwK","item":"AccordionItemBlok_item__GKroO","trigger":"AccordionItemBlok_trigger__5hckC","content":"AccordionItemBlok_content__kyMWS"};